import { getApiUrl, AXIOS_AUTHED, DEFAULT_PAGEABLE } from './shared';

const get = () => {
  return AXIOS_AUTHED.get(`${getApiUrl()}/mrs-items`);
};

const getDispenserLookups = () => {
  return AXIOS_AUTHED.get(`${getApiUrl()}/dispenser-lookups`);
};

export { get, getDispenserLookups };
